export default {
    "fr": {
        "View": "Voir",
        "Search": "Rechercher",
        "Close": "Fermer",
        "Update": "Modifier",
        "Send": "Envoyer",
        "Save": "Sauvegarder",
        "Pictures": "Photos",
        "Attach files": "Joindre des fichiers",
        "Drop your pictures here": "Déposez vos photos ici",
        "old": "Ancien",
        "new": "Nouveau",
        "View site": "Voir le site",
        "Booking type": "Réservation - {0}",
        "close": "Closed",
        "open": "Opened",
        "types": {
            "animals": "Animaux",
            "food-animal": "Nourriture d’origine animal",
            "food-vegetable": "Nourriture d’origine végétal",
            "plants": "Plantes",
            "customs": "Représentation auprès de la douane (contrôle)",
            "customs-cts": "Assistance Douane sur Parking",
            "customs-complete": "Dédouanement Import / Export / Transit",
            "vehicle": "Véhicule",
            "goods-sivep": "Marchandise soumise à contrôle SIVEP",
            "moving": "Déménagement",
            "military_equipment": "Matériel militaire",
            "industrial_equipment": "Matériel industriel",
            "aero_parts": "Pièces Avion",
            "sanitary": "Sanitaire",
            "medicine": "Médicaments",
            "alcohol": "Alcool",
            "personal_effects": "Effets personnels",
            "miscellaneous": "Divers"
        },
        "types_short": {
            "animals": "Animaux",
            "food-animal": "Nour. animal",
            "food-vegetable": "Nour. végétal",
            "plants": "Plantes",
            "customs": "Douane",
            "customs-cts": "Calais Truck Stop",
            "customs-complete": "Douane complète",
            "vehicle": "Véhicule",
            "goods-sivep": "Marchandise SIVEP",
            "moving": "Déménagement",
            "military_equipment": "Matériel militaire",
            "industrial_equipment": "Matériel industriel",
            "aero_parts": "Pièces Avion",
            "sanitary": "Sanitaire",
            "medicine": "Médicaments",
            "alcohol": "Alcool",
            "personal_effects": "Effets personnels",
            "miscellaneous": "Divers"
        },
        "sites": {
            "calais-port": "Calais Port",
            "calais-truck-stop": "Calais Truck Stop",
            "calais-shuttle": "Calais Tunnel",
            "boulogne-port": "Boulogne Port",
            "dunkirk-port": "Dunkerque Port",
            "customs-department": "Département Douane"
        },
        "documents": {
            "document": "Document",
            "mandate": "Mandat de représentation",
            "customs": "Document douanier",
            "sanitary-certificate": "Certificat sanitaire",
            "pet-passport": "Passeport animal",
            "driver-certificate": "Agrément du véhicule et du chauffeur",
            "coggin-certificate": "Certificat de test Coggins",
            "merchandise-certificate": "Attestation marchandise",
            "export-declaration": "Déclaration export",
            "mrn-export": "MRN export - En cours de sortie",
            "export-tax-proof": "Preuve fiscale d’exportation",
            "import-declaration": "Déclaration import. Preuve fiscale d’importation",
            "transit": "Transit",
            "ata": "ATA",
            "cs-hc": "CS / HC",
            "ex-eu": "EX / EU",
            "ens": "ENS",
            "invoice": "Facture",
            "packing-list": "Liste de colisage",
            "dae": "DAE",
            "ched": "DSCE / CHED",
            "cmr": "CMR",
            "barcode": "Code barre",
            "gray-card": "Carte grise",
            "certificate-conformity": "Certificat de conformité",
            "customs-power-attorney": "Mandat de représentation en douane",
            "mandate-simplified": "Mandat simplifié",
            "mandate-complete": "Mandat complet",
            "pod": "POD - Preuve de livraison"
        },
        "checkpoints": {
            "horses": "Chevaux",
            "chicks": "Poussins",
            "dogs_cats": "Chiens / Chats",
            "sivep_formalities": "Formalités SIVEP",
            "dsce": "DSCE validé",
            "documentary_control": "Contrôle documentaire",
            "identity_control": "Contrôle identité",
            "physical_control": "Contrôle physique",
            "handling": "Manutention",
            "consignment": "Consignation",
            "customs_formalities": "Formalités douanière",
            "liquidation_office": "Liquidation d'office",
            "liquidation_office_reference": "Liquidation d'office : Référence",
            "liquidation_office_amount": "Liquidation d'office : Montant LO",
            "animal_station": "Passage station animalière",
            "animal_station_type": "Type d'animaux",
            "horses_count": "Nombre de chevaux",
            "horses_with_box": "Chevaux mis en box",
            "cts_customs_documents": "Documents douane",
            "cts_status": "Statut",
            "customs": "Douane",
            "carnet_846a": "Carnet 846A",
            "animals_count": "Nombre d'animaux",
            "consignment_units_count": "Consignation : nombre d'unités",
            "consignment_days_count": "Consignation : nombre de jours",
            "liquidation_office_dynamic": "Liquidation d'office",
            "documents_ok": "Documents conformes",
            "declaration_ready": "Déclaration prête",
            "declaration_bae": "Déclaration BAE",
            "cross_channel_boarding": "Embarquement transmanche",
            "dsce_validated": "DSCE validé",
            "notification_arrived": "Notification d'arrivée",
            "horses_with_box_count": "Nombre de chevaux mis en box",
            "horses_without": "Chevaux sans descente et sans box",
            "horses_without_count": "Nombre de chevaux sans descente et sans box",
            "horses_with_descent": "Chevaux avec descente et sans box",
            "horses_with_descent_count": "Nombre de chevaux avec descente et sans box",
            "dogs_cats_count": "Nombre de chiens / chats",
            "dogs_cats_caging": "Chiens / Chats en cages",
            "dogs_cats_caging_count": "Nombre de chiens / chats en cage",
            "chicks_count": "Nombre de poussins",
            "chicks_without_control": "Poussins sans contrôle",
            "chicks_without_control_count": "Nombre de poussins sans contrôle",
            "chicks_with_control": "Poussins en contrôle",
            "chicks_with_control_count": "Nombre de poussins en contrôle",
            "levy": "Prélèvement",
            "ens": "Préparation du document ENS"
        },
        "animals": {
            "horses": "Chevaux",
            "dogs_cats": "Chiens/Chats",
            "chicks": "Poussins"
        },
        "An error has occured": "Une erreur est apparue",
        "payments": {
            "prepayment": "Prépaiement",
            "later": "Paiement plus tard",
            "cash": "Cash",
            "credit-card": "Carte de crédit",
            "group": "Grouper en fin de mois"
        }
    },
    "en": {
        "View": "View",
        "Search": "Search",
        "Close": "Close",
        "Update": "Update",
        "Send": "Send",
        "Save": "Save",
        "Pictures": "Pictures",
        "Attach files": "Attach files",
        "Drop your pictures here": "Drop your pictures here",
        "old": "Old",
        "new": "New",
        "View site": "View site",
        "Booking type": "Booking - {0}",
        "types": {
            "animals": "Animals",
            "food-animal": "Food of animal origin",
            "food-vegetable": "Food of vegetable origin",
            "plants": "Plants",
            "customs": "Representation at customs only",
            "customs-cts": "Customs assistance on parking",
            "customs-complete": "Import / Export / Transit customs clearance",
            "vehicle": "Véhicle",
            "goods-sivep": "SIVEP goods",
            "moving": "Moving",
            "military_equipment": "Military equipment",
            "industrial_equipment": "Industrial equipment",
            "aero_parts": "Aero parts",
            "sanitary": "Sanitary",
            "medicine": "Medicine",
            "alcohol": "Alcohol",
            "personal_effects": "Personal effects",
            "miscellaneous": "Miscellaneous"
        },
        "types_short": {
            "animals": "Animals",
            "food-animal": "Food of animal origin",
            "food-vegetable": "Food of vegetable origin",
            "plants": "Plants",
            "customs": "Representation at customs only",
            "customs-cts": "Customs assistance on parking",
            "customs-complete": "Import / Export / Transit customs clearance",
            "vehicle": "Véhicle",
            "goods-sivep": "SIVEP goods",
            "moving": "Moving",
            "military_equipment": "Military equipment",
            "industrial_equipment": "Industrial equipment",
            "aero_parts": "Aero parts",
            "sanitary": "Sanitary",
            "medicine": "Medicine",
            "alcohol": "Alcohol",
            "personal_effects": "Personal effects",
            "miscellaneous": "Miscellaneous"
        },
        "sites": {
            "calais-port": "Calais Port",
            "calais-truck-stop": "Calais Truck Stop",
            "calais-shuttle": "Calais Tunnel",
            "boulogne-port": "Boulogne Port",
            "dunkirk-port": "Dunkirk Port",
            "customs-department": "Customs Department"
        },
        "documents": {
            "document": "Document",
            "mandate": "Mandate",
            "customs": "Customs document",
            "sanitary-certificate": "Sanitary certificate",
            "pet-passport": "Pet passport",
            "driver-certificate": "Driver certificate",
            "coggin-certificate": "Coggin certificate",
            "merchandise-certificate": "Merchandise certificate",
            "export-declaration": "Export declaration",
            "mrn-export": "MRN export - In progress",
            "export-tax-proof": "Export tax proof",
            "import-declaration": "Import declaration. Tax proof of import",
            "transit": "Transit",
            "ata": "ATA",
            "cs-hc": "CS / HC",
            "ex-eu": "EX / EU",
            "ens": "ENS",
            "invoice": "Invoice",
            "packing-list": "Packing list",
            "dae": "DAE",
            "ched": "CHED",
            "cmr": "CMR",
            "barcode": "barcode",
            "gray-card": "V5",
            "certificate-conformity": "Certificate of conformity",
            "customs-power-attorney": "Customs Power of attorney",
            "pod": "POD - Proof of delivery"
        },
        "checkpoints": {
            "horses": "Horses",
            "chicks": "Chicks",
            "dogs_cats": "Dogs / Cats",
            "sivep_formalities": "SIVEP Formalities",
            "dsce": "CHED",
            "documentary_control": "Documentary control",
            "identity_control": "Identity control",
            "physical_control": "Physical control",
            "handling": "Handling",
            "consignment": "Consignment",
            "customs_formalities": "Customs formalities",
            "liquidation_office": "Tax & fees statement",
            "liquidation_office_reference": "Tax & fees statement : Reference",
            "liquidation_office_amount": "Tax & fees statement : Amount",
            "animal_station": "Passage animal station",
            "animal_station_type": "Type of animals",
            "horses_count": "Number of horses",
            "horses_with_box": "Horses with box",
            "cts_customs_documents": "Customs documents",
            "cts_status": "Status",
            "customs": "Customs",
            "carnet_846a": "846A carnet",
            "animals_count": "Number of animals",
            "consignment_units_count": "Consignment : Number of units",
            "consignment_days_count": "Consignment : Number of days",
            "liquidation_office_dynamic": "Liquidation d'office",
            "documents_ok": "Documents are compliant",
            "declaration_ready": "Customs declaration ready",
            "declaration_bae": "Customs declaration released by customs",
            "cross_channel_boarding": "Confirmation of cross-Channel boarding",
            "dsce_validated": "CHED validated",
            "notification_arrived": "Arrival notification",
            "horses_with_box_count": "Number of horses with box",
            "horses_without": "Horses without descent and without box",
            "horses_without_count": "Number of horses without descent and without box",
            "horses_with_descent": "Horses with descent and without box",
            "horses_with_descent_count": "Number of horses with descent and without box",
            "dogs_cats_count": "Number of dogs / cats",
            "dogs_cats_caging": "Dogs / Cats in cages",
            "dogs_cats_caging_count": "Number of dogs / cats in cage",
            "chicks_count": "Number of chicks",
            "chicks_without_control": "Chicks without control",
            "chicks_without_control_count": "Number of chicks without control",
            "chicks_with_control": "Chicks in control",
            "chicks_with_control_count": "Number of chicks in control",
            "levy": "Levy",
            "ens": "ENS document preparation"
        },
        "animals": {
            "horses": "Horses",
            "dogs_cats": "Dogs/Cats",
            "chicks": "Chicks"
        },
        "An error has occured": "An error has occured"
    }
}
